module.exports = __webpack_public_path__ + "img/logo_noudata.a3663e6e.png";